async function updateLineItemGiftWrapOption(key, is_gift_wrapped) {
  //console.log("starting")
  //theme.js 2874

  let result1 = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  let cartData1 = await result1.json();
  const found = cartData1.items.find((element) => element.key === key);
  if (!found) {
    return;
  }
  let current_properties = found.properties;
  let current_quantity = found.quantity;

  current_properties["_is_gift_wrapped"] = is_gift_wrapped;

  let data = {
    id: key,
    properties: current_properties,
    quantity: current_quantity,
  };

  const changeResult = await fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const cartData = await changeResult.json();
  const configElement = document.getElementById("cart-config");
  if (configElement && window.Shopify?.theme?.ajaxCart?.updateView) {
    const config = JSON.parse(configElement.textContent || "{}");
    Shopify.theme.ajaxCart.updateView(config, cartData);
  }
  // Shopify.theme.ajaxCart.init();

  //console.log("finished")
}

async function refreshLineItemGiftWrapOption() {
  let result = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

   let cartData = await result.json();
  console.log(cartData);
  // Shopify.theme.ajaxCart.init();

  //console.log("finished")
}
